import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes,RouterModule } from '@angular/router';
import { QuestionCreatorComponent } from './question-creator/question-creator.component';
import { ListQuestionsComponent } from './list-questions/list-questions.component';
import { SubtypeCreationComponent } from './subtype-creation/subtype-creation.component';
import { AssessmentCreatorComponent } from './assessment-creator/assessment-creator.component';
import { AssessmentBuilderComponent } from './assessment-builder/assessment-builder.component';
import { AssessmentAttemptComponent } from './assessment-attempt/assessment-attempt.component';
import { LoginComponent } from './view/login/login.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { UserPerformanceDashboardComponent } from './commons/user-performance-dashboard/user-performance-dashboard.component';
import { ProfessionScoreManagerComponent } from './profession-score-manager/profession-score-manager.component';
import { BehaviorCategoriesManagerComponent } from './behavior-categories-manager/behavior-categories-manager.component';
import { LoginPageComponent } from './view/login-page/login-page.component';
// import { L } from '@angular/cdk/a11y-module.d-DBHGyKoh';
import { AuthGuard } from './services/auth-gaurd.service';
import { RecruiterGuard } from './services/recruiter-guard.service';
import { RecruitmentShellComponent } from './recruitment/recruitment-shell/recruitment-shell.component';
import { RecruitmentDashboardComponent } from './recruitment/recruitment-dashboard/recruitment-dashboard.component';
import { BenchmarkListComponent } from './recruitment/benchmark-list/benchmark-list.component';
import { BenchmarkDetailComponent } from './recruitment/benchmark-detail/benchmark-detail.component';
import { CandidateListComponent } from './recruitment/candidate-list/candidate-list.component';
import { CandidateDetailComponent } from './recruitment/candidate-detail/candidate-detail.component';
import { JoinOrganizationComponent } from './recruitment/join-organization/join-organization.component';
import { ProfileComponent } from './profile/profile.component';
// import { OtpComponent } from './view/otp/otp.component';

const routes : Routes = [
  //public
  {path:'',component:LoginPageComponent},
  {path:'login',component:LoginPageComponent},
  {path:'join/:token',component:JoinOrganizationComponent},
  {
    path: 'recruitment',
    component: RecruitmentShellComponent,
    canActivate: [RecruiterGuard],
    children: [
      { path: '', component: RecruitmentDashboardComponent },
      { path: 'benchmarks', component: BenchmarkListComponent },
      { path: 'benchmarks/:benchmarkId', component: BenchmarkDetailComponent },
      { path: 'candidates', component: CandidateListComponent },
      { path: 'candidates/:candidateId', component: CandidateDetailComponent },
    ]
  },
  // protected routes
  {path:'list-questions',component:ListQuestionsComponent, canActivate: [AuthGuard]},
  {path:'list-types',component:SubtypeCreationComponent, canActivate: [AuthGuard]},
  {path:'create-question',component:QuestionCreatorComponent, canActivate: [AuthGuard]},
  {path:'assesments',component:AssessmentCreatorComponent,  canActivate: [AuthGuard]},
  {path:'profile',component:ProfileComponent, canActivate: [AuthGuard]},
  {path:'assessment-builder',component:AssessmentBuilderComponent, canActivate: [AuthGuard]},
  {path:'start-assessment',component:AssessmentAttemptComponent, canActivate: [AuthGuard]},
  {path:'admin-dashboard',component:AdminDashboardComponent,  canActivate: [AuthGuard]},
  // {path:'login',component:LoginComponent},
  {path:'user-dashboard',component:UserPerformanceDashboardComponent, canActivate: [AuthGuard]},
  {path: 'manage-scores', component: ProfessionScoreManagerComponent,   canActivate: [AuthGuard] },
  { path: 'manage-behavior-categories', component: BehaviorCategoriesManagerComponent, canActivate: [AuthGuard] },
  // if no match, redirect to login
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})
  ],
  exports:[RouterModule]
})
export class AppRoutingModule { }
